var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRanus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 85,
    height: 17,
    viewBox: "0 0 85 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11902_2475)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M75.681 2.43055H84.2748V0H73.2087C72.2316 0 71.2945 0.383748 70.6036 1.06682C69.9127 1.7499 69.5246 2.67635 69.5246 3.64236V9.6945H79.3301V13.3369C79.3283 13.6535 79.2012 13.9568 78.9761 14.182C78.751 14.4072 78.4456 14.5363 78.1254 14.5417H69.5246V16.9723H80.5838C81.0678 16.9732 81.5473 16.8796 81.9947 16.6969C82.4421 16.5142 82.8486 16.2459 83.1909 15.9075C83.5331 15.5691 83.8045 15.1672 83.9893 14.7249C84.1741 14.2826 84.2688 13.8085 84.2678 13.3299V7.28472H74.4624V3.64236C74.4624 3.32217 74.5905 3.01498 74.8189 2.78792C75.0472 2.56086 75.3572 2.43238 75.681 2.43055Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1565 0V14.5417H59.6982C59.0474 14.5418 58.4231 14.2866 57.9623 13.8323C57.5015 13.378 57.2416 12.7615 57.2398 12.1181V0H52.337V12.1458C52.337 13.4314 52.8536 14.6643 53.773 15.5733C54.6925 16.4824 55.9395 16.9931 57.2398 16.9931H67.0453V0H62.1565Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.0452 17V2.45825H42.5035C43.1477 2.45818 43.7659 2.70877 44.2246 3.15583C44.6834 3.60288 44.9457 4.21048 44.9549 4.84725V17H49.8576V4.84725C49.8576 3.56168 49.3411 2.32876 48.4217 1.41973C47.5022 0.510691 46.2552 0 44.9549 0H35.1494V17H40.0452Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4474 6.07291V4.84725C15.4474 3.56168 14.9308 2.32876 14.0114 1.41973C13.0919 0.510691 11.8449 0 10.5446 0H0.739136V17H5.64188V2.45825H8.10026C8.74261 2.46177 9.35806 2.71374 9.81489 3.16023C10.2717 3.60671 10.5337 4.21225 10.5446 4.84725V6.07291C10.5446 6.71753 10.2856 7.33575 9.82458 7.79157C9.36355 8.24739 8.73825 8.50346 8.08625 8.50346H6.88157V10.9271H8.10726C8.75561 10.9326 9.37553 11.1911 9.83203 11.6463C10.2885 12.1015 10.5446 12.7166 10.5446 13.3576V17H15.4474V13.3576C15.4549 12.6674 15.3131 11.9835 15.0317 11.3518C14.7503 10.72 14.3356 10.155 13.8155 9.6945C14.3303 9.23866 14.7418 8.68035 15.0231 8.05621C15.3043 7.43207 15.4489 6.75619 15.4474 6.07291Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8505 0C21.5502 0 20.3032 0.510691 19.3837 1.41973C18.4643 2.32876 17.9478 3.56168 17.9478 4.84725V17H22.8505V10.9271H26.5346V8.50346H22.8505V4.84725C22.8505 4.20446 23.1088 3.58801 23.5685 3.13349C24.0282 2.67897 24.6517 2.42363 25.3019 2.42363H27.7602V16.9654H32.663V0H22.8505Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11902_2475"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 83.5217,
    height: 17,
    fill: "white",
    transform: "translate(0.739136)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanus);
export default __webpack_public_path__ + "static/media/Ranus.32f1f29dbafdbde065161d97e936d041.svg";
export { ForwardRef as ReactComponent };